import {
    mediaQueries, space, colors, radii
} from 'style/config';

const styles = {
    increaseATBButtonOnPdp: { [mediaQueries.lg]: { height: `${space[7]}px`, maxHeight: 'none' } },
    skuQuantity: {
        color: colors.white,
        backgroundColor: 'transparent',
        border: 0,
        borderTopLeftRadius: radii.full,
        borderBottomLeftRadius: radii.full
    },
    skuQuantityAlt: bw => ({
        color: colors.white,
        border: 0,
        borderRadius: radii.full,
        [mediaQueries.smMax]: { width: '100%' },
        [mediaQueries.md]: { width: bw }
    }),
    quantityPicker: show => ({
        position: show ? 'relative' : 'absolute',
        borderRight: `1px solid ${colors.white}`,
        width: show ? '100%' : 'auto',
        boxSizing: 'border-box',
        [mediaQueries.lg]: { height: '100%', display: 'flex', alignItems: 'center' }
    })
};

export { styles };
